/**
 * useTimelineScroll Hook
 *
 * Manages synchronized scrolling between header, y-axis, and content areas.
 * Content drives the scroll; header and y-axis follow.
 */

import { useCallback } from 'react'

/**
 * useTimelineScroll - Synchronized scroll handler
 *
 * Synchronizes:
 * - Header horizontal scroll ← Content horizontal scroll
 * - Y-axis vertical scroll ← Content vertical scroll
 *
 * @param {Object} params
 * @param {Object} params.headerRef - Header container ref
 * @param {Object} params.yAxisRef - Y-axis container ref
 *
 * @returns {Object} { handleContentScroll }
 */
export const useTimelineScroll = ({ headerRef, yAxisRef }) => {
  const handleContentScroll = useCallback((e) => {
    const { scrollLeft, scrollTop } = e.target

    // Sync header horizontal scroll
    if (headerRef.current) {
      headerRef.current.scrollLeft = scrollLeft
    }

    // Sync y-axis vertical scroll
    if (yAxisRef.current) {
      yAxisRef.current.scrollTop = scrollTop
    }
  }, [headerRef, yAxisRef])

  return { handleContentScroll }
}
